module.exports = __webpack_public_path__ + "static/media/manager-icon.de1a7b67.svg";